import { useRef, useState } from 'react';
import { Menu } from 'primereact/menu';
import { FiBookOpen, FiFolder, FiLayers, FiMoreHorizontal } from 'react-icons/fi';

export default function TaxonomyItem({ item, kind, onAction }) {
    const menu = useRef(null);
    const trigger = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const knownCount = item.books_count != null;
    const count = knownCount ? Number(item.books_count) : null;
    const tone = kind === 'category' ? 'green' : ['green', 'amber', 'blue', 'rose'][String(item.name).charCodeAt(0) % 4];
    const Icon = kind === 'category' ? FiFolder : FiLayers;
    const menuId = `taxonomy-${kind}-${item.id}-menu`;
    return <li className={`taxonomy-item taxonomy-item-${kind}`}>
        <div className={`taxonomy-item-icon taxonomy-tone-${tone}`}><Icon aria-hidden="true" /></div>
        <div className="taxonomy-item-copy"><h3>{item.name}</h3>
            <span className={`taxonomy-book-count${count === 0 ? ' taxonomy-book-count-empty' : ''}`}><FiBookOpen aria-hidden="true" />{knownCount ? `${count} ${count === 1 ? 'book' : 'books'}` : 'Book count unavailable'}</span>
        </div>
        <Menu popup ref={menu} id={menuId} className="taxonomy-item-menu" onShow={() => setMenuOpen(true)} onHide={() => setMenuOpen(false)} model={[
            { label: 'Rename', icon: 'pi pi-pencil', command: () => onAction(kind, 'rename', item, trigger.current) },
            { label: 'Delete', icon: 'pi pi-trash', className: 'taxonomy-menu-delete', command: () => onAction(kind, 'delete', item, trigger.current) },
        ]} />
        <button type="button" ref={trigger} className="taxonomy-item-more" aria-label={`Actions for ${kind} ${item.name}`} title={`Manage ${item.name}`} aria-haspopup="menu" aria-expanded={menuOpen} aria-controls={menuId} onClick={(event) => menu.current.toggle(event)}><FiMoreHorizontal aria-hidden="true" /></button>
    </li>;
}
